import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { Background } from './Background';
import { FADE, MAX_LEADERS } from '../../HOME/const';
import * as f from '../logic';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { CM_BACKGROUND } from '../const';
import { setUserId, showLeaderboards } from '../../HOME/REDUX/actions';
import { pause } from '../REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    size: this.props.size,
  };

  componentDidMount() {
    this.props.pause(true);
    this.init(this.handleSelection);
  }

  getQuery = () => {
    const { size } = this.state;

    return this.leaders
      .where('size', '==', size)
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey(size) {
    size = size === undefined ? this.state.size : size;

    return `${this.props.app} LEADERS • ${size}`;
  }

  userKey(id, size) {
    id = id || this.props.uid;
    size = size === undefined ? this.state.size : size;

    return `${size} • ${id}`;
  }

  handleSelection = size => {
    size = size === undefined ? this.state.size : size;

    this.setState({ size }, () => {
      this.getCachedLeaders(true);

      f.getStats(size, stats => {
        let score;
        const { plays } = stats;

        if (size) {
          const { aveSecs } = stats;
          let aveScore = f.scoreFromSecs(aveSecs, size);

          if (aveScore === 1000) {
            aveScore = 0;
          }

          score = f.getGrade(aveScore, plays);
        } else {
          score = stats.bestScore;
        }

        this.setState({ score, plays }, this.updateRanks);
      });
    });
  };

  dataToSubmit = () => {
    const { size, score, plays } = this.state;
    return { size, name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton color="white" />
      <HomeButton />
    </>
  );

  sizeBackground = (size, opacity = 'FF') => {
    switch (size) {
      case 10:
        return `#7FA1E9${opacity}`;
      case 25:
        return `#8AC273${opacity}`;
      case 50:
        return `#FFC000${opacity}`;
      case 100:
        return `#FF8080${opacity}`;
      case 0:
        return `#FF6400${opacity}`;
      default:
    }
  };

  render() {
    const background = CM_BACKGROUND;
    const rankColor = this.sizeBackground(this.state.size);
    const submitColor = this.sizeBackground(this.state.size, 'A0');
    const scoreAlias = this.state.size ? 'Grade' : 'Best';

    return (
      <>
        <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
          {this.renderClickableScreen()}
          <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
            <div className="leaders-selector">
              {_.map([10, 25, 50, 100, 0], size => {
                const current = size === this.state.size;
                const sizeName = size || 'T';
                const cls = `leaders-circle re-leaders-size-selector leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                const background = this.sizeBackground(size);
                return (
                  <div key={size} className={cls} style={{ margin: '0 0.5em', background }} onClick={() => this.handleSelection(size)}>
                    {sizeName}
                  </div>
                );
              })}
            </div>
            <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
              {_.map(this.state.users, (u, i) => (
                <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} scoreAlias={scoreAlias} />
              ))}
            </div>
            {this.renderCommon(rankColor, submitColor, scoreAlias)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ cm, common }) {
  return { ...cm, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards, pause }
)(Leaderboard);
